<template>
  <div id="zoom-control" :class="{ disabled }">
    <!-- Zoom in -->
    <x-button
      appearance-size="small"
      appearance-color="secondary-white"
      data-test="zoom-in"
      class="zoom-button"
      @click="handleZoomIn"
    >
      <span class="accessible-name">Zoom In</span>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="6" width="2" height="14" />
        <rect y="6" width="14" height="2" />
      </svg>
    </x-button>

    <div class="zoom-control__divider" />

    <!-- Zoom out -->
    <x-button
      appearance-size="small"
      appearance-color="secondary-white"
      data-test="zoom-out"
      class="zoom-button"
      @click="handleZoomOut"
    >
      <span class="accessible-name">Zoom In</span>
      <svg
        width="14"
        height="2"
        viewBox="0 0 14 2"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="14" height="2" />
      </svg>
    </x-button>
  </div>
</template>

<!-- eslint-disable vue/block-lang -->
<script>
/* eslint-disable vue/component-api-style */
import { zoom } from '@/services/map-service'
import xButton from '@/components/shared/x-button'

export default {
  name: 'ControlZoom',

  components: { xButton },

  props: {
    disabled: {
      type: Boolean,
    },
  },

  methods: {
    handleZoomIn() {
      this._handleZoom(1)
    },

    handleZoomOut() {
      this._handleZoom(-1)
    },

    _handleZoom(deltaZoom) {
      zoom(deltaZoom)
    },
  },
}
</script>

<style scoped lang="scss">
@use '@/styles/system/_colors.scss';
@use '@/styles/system/_shadow.scss';
@use '@/styles/system/_elements.scss';
@use '@/styles/system/_breakpoints.scss';

#zoom-control {
  box-shadow: shadow.$Low;
  border-radius: 10px;
  overflow: hidden;
  background: colors.$BaseWhite;
  position: relative;

  @include breakpoints.mobile() {
    display: none;
  }

  .x-button {
    margin: 0;
    padding: 0;
    height: 45px;
    width: 45px;

    svg {
      fill: colors.$BaseBlack;
    }
  }

  .zoom-control__divider {
    height: 1px;
    width: 75%;
    background-color: colors.$Grey30;
    margin: -1px auto 0;
  }

  .accessible-name {
    font-size: 0;
  }

  svg {
    pointer-events: none;
  }

  &.disabled::before {
    @include elements.disabledOverlay();
  }
}

@media print {
  #zoom-control {
    display: none;
  }
}
</style>
